import { AuthenticationAssuranceLevel, ScopeType, AuditPolicy, IdempotencyPolicy, ConcurrencyPolicy, PrivacyClassification, ActorType, } from './operation.js';
/** Cross-instrument list/detail operations for market snapshots and valuation observations. */
export const MARKET_PRICES_LIST = 'market.prices.list';
export const MARKET_PRICES_GET = 'market.prices.get';
function marketDataRead(id, name, labelKey, descriptionKey) {
    return {
        id,
        name,
        labelKey,
        descriptionKey,
        permission: 'organization:market-data:read',
        permissionId: 'organization:market-data:read',
        module: 'MARKET_DATA',
        requiredModules: ['MARKET_DATA'],
        requiresEntitledModule: true,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH'],
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN', 'ORG_ADMIN'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: id,
        allowedActorTypes: [ActorType.USER, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    };
}
export const MARKET_DATA_OPERATIONS = {
    [MARKET_PRICES_LIST]: marketDataRead(MARKET_PRICES_LIST, 'List Market Data', 'operations.marketData.prices.list.label', 'operations.marketData.prices.list.description'),
    [MARKET_PRICES_GET]: marketDataRead(MARKET_PRICES_GET, 'Read Market Data Observation', 'operations.marketData.prices.get.label', 'operations.marketData.prices.get.description'),
};
